import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { ClientProfileFeature } from '@/features/client-profile/ClientProfileFeature'
import { clientProfileSearchSchema } from '@/features/client-profile/clientProfileSearch'
import { useClient } from '@/entities/client/model/queries'
import { Skeleton } from '@/shared/components/ui/skeleton'

export const Route = createFileRoute('/clients/$clientId/')({
  component: ClientDetailPage,
  staticData: { authorize: true },
  validateSearch: clientProfileSearchSchema,
})

function ClientDetailPage() {
  const { clientId } = Route.useParams()
  const clientIdNum = parseInt(clientId)
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  // Use client hook with initial data from router state
  // If state has client data, it won't make an API call
  // If state is empty (e.g., direct URL access), it will fetch from API
  const { data: client, isLoading } = useClient(clientIdNum)

  if (isLoading) {
    return (
      <div className="space-y-6">
        <Skeleton className="h-12 w-3/4" />
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-64 w-full" />
      </div>
    )
  }

  if (!client) {
    return (
      <div className="flex flex-col items-center justify-center p-12">
        <p className="text-lg font-medium">Client not found</p>
        <p className="text-sm text-muted-foreground">
          The client you're looking for doesn't exist.
        </p>
      </div>
    )
  }

  return (
    <ClientProfileFeature
      client={client}
      clientId={clientIdNum}
      search={search}
      onSearchChange={(next) => navigate({ search: next, replace: true })}
    />
  )
}
